import {defineNuxtPlugin} from "#app";
import SmartLook from "smartlook-client";

export default defineNuxtPlugin(async () => {
  if (process.client) {
    SmartLook.init(import.meta.env.VITE_SMARTLOOK_KEY, {region: 'eu'})
    console.log('SmartLook is initialized')
  }
})
